export const CUSTOMER_TYPES = {
  PUBLIC: 'PÚBLICO',
  PRIVATE: 'PRIVADO',
};
